export default __webpack_public_path__ + "static/media/notification-invoice.5a821abe.svg";